import {
    Button,
    TextField,
    MuiThemeProvider,
    createMuiTheme
} from '@material-ui/core'
import React, { useEffect, useState } from 'react'
import { useHistory, useParams } from 'react-router-dom'
import { Card, CardBody, CardHeader } from '../../../../_metronic/_partials/controls'
import { alertError, alertSuccess } from '../../../../utils/logger'
import Editor from '../../../components/editor/Editor'
import MultilanguageTabBlock from '../../../components/MultilanguageTabBlock'
import { useSkeleton } from '../../../hooks/useSkeleton'
import ConfirmDialog from "../../../components/dialogs/ConfirmDialog";
import { deleteManufacturer, getManufacturerById, postManufacturer, updateManufacturer } from '../../../../api/manufacturers'
import { Autocomplete } from '@material-ui/lab'

// Create theme for delete button (red)
const theme = createMuiTheme({
    palette: {
        secondary: {
            main: "#F64E60",
        },
    },
});

function getEmptyManufacturer() {
    return {
        fullName: "" /*{
            'es': "",
            'en': ""
        }*/,
        description: {
            'es': "",
            'en': ""
        },
        cif: null,
        type: []
    }
}

export default function EditManufacturerPage() {
    const manufacturerId = useParams().id;
    const history = useHistory();
    const { isLoading: isLoadingData, disableLoading: disableLoadingData, ContentSkeleton } = useSkeleton();

    const [manufacturer, setManufacturer] = useState(getEmptyManufacturer())
    const [openConfirmDialog, setOpenConfirmDialog] = useState(false);

    const manufacturerTypes = ["Modules", "Turbine", "Battery", "Electrolyzer", "Inverter"]

    useEffect(() => {
        if (!manufacturerId) {
            disableLoadingData();
            return
        }

        getManufacturerById(manufacturerId).then(res => {
            setManufacturer(res.data)
            disableLoadingData()
        }).catch(error => {
            alertError({ error: error, customMessage: 'Could not get manufacturer.' })
            history.push('/manufacturers')
        })
    }, [manufacturerId, disableLoadingData, history])

    function saveManufacturer() {
        if (!manufacturerId) {
            postManufacturer(manufacturer)
                .then((res) => {
                    alertSuccess({
                        title: "Saved!",
                        customMessage: "Manufacturer created successfully.",
                    });
                    history.push("/manufacturers");
                })
                .catch((error) => {
                    alertError({
                        error: error,
                        customMessage: "Could not save the manufacturer.",
                    });
                });
        } else {
            updateManufacturer(manufacturerId, manufacturer).then(res => {
                alertSuccess({ title: 'Saved!', customMessage: 'Changes successfully saved.' })
                history.push('/manufacturers')
            }).catch(error => {
                alertError({ error: error, customMessage: 'Could not save changes.' })
            })
        }
    }

    const handleChange = (element, lang) => (event) => {
        if (lang) {
            if (event.target.value === ' ')
                return
            if (!manufacturer[element])
                manufacturer[element] = {}
            let newText = manufacturer[element]
            newText[lang] = event.target.value
            setManufacturer({ ...manufacturer, [element]: newText })
        } else
            setManufacturer({ ...manufacturer, [element]: event.target.value })
    }

    const handleChangeEditor = (element, lang, value) => {
        if (lang) {
            if (value === ' ')
                return
            if (!manufacturer[element])
                manufacturer[element] = {}
            let newText = manufacturer[element]
            newText[lang] = value
            setManufacturer({ ...manufacturer, [element]: newText })
        } else
            setManufacturer({ ...manufacturer, [element]: value })
    }


    const renderMultilanguageTabContent = lang => {
        return (
            <>
                <div className="d-flex align-items-center mt-5 mb-5">
                    <div className='col-4'>
                        <TextField
                            label="Manufacturer Name"
                            value={manufacturer.fullName || ''}
                            onChange={handleChange('fullName')}
                            margin="normal"
                            variant="outlined"
                            required
                        />
                    </div>
                    <div className="col-4">
                        <TextField
                            label="CIF/SIRET"
                            value={manufacturer.cif}
                            onChange={handleChange('cif')}
                            margin="normal"
                            variant="outlined"
                        />
                    </div>
                    <div className="col-4">
                        <Autocomplete
                            id='types'
                            options={manufacturerTypes}
                            value={manufacturer?.type || ''}
                            onChange={(_, newValue) => {
                                setManufacturer({
                                    ...manufacturer,
                                    type: newValue
                                })
                            }}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    label='Manufacturer Types'
                                    margin="normal"
                                    variant="outlined"
                                    required
                                />
                            )}
                            multiple
                        />
                    </div>
                </div>

                <div className="d-flex align-item-center">
                    <div className='col-12'>
                        <Editor
                            body={(manufacturer.description && manufacturer.description[lang]) || ''}
                            setBody={new_body => handleChangeEditor('description', lang, new_body)}
                            className='max-height'
                            lang={lang}
                            placeholder={'Enter text content here...'}
                        />
                    </div>

                </div>

            </>
        )
    }

    if (isLoadingData)
        return <ContentSkeleton />

    return (
        <>
            <Card>
                <CardHeader title='Edit manufacturer'>
                </CardHeader>
                <CardBody>
                    <MultilanguageTabBlock
                        multilanguageTabContent={renderMultilanguageTabContent}
                    />
                </CardBody>
            </Card>
            <Button
                onClick={() => history.push('/manufacturers')}
                variant="outlined"
                style={{ marginRight: '20px' }}>
                Back
            </Button>
            <Button
                onClick={() => saveManufacturer()}
                variant="outlined"
                color="primary"
                style={{ marginRight: '20px' }}>
                Save manufacturer
            </Button>

            {manufacturerId && (
                <>
                    <MuiThemeProvider theme={theme}>
                        <Button
                            onClick={() => setOpenConfirmDialog(true)}
                            variant="outlined"
                            color="secondary"
                            style={{ marginRight: "20px" }}
                        >
                            Delete manufacturer
                        </Button>
                        <div
                            style={{
                                display: "flex",
                                flexDirection: "row",
                                marginLeft: "auto",
                            }}
                        ></div>
                    </MuiThemeProvider>

                    <ConfirmDialog
                        title={"Are you sure you want to delete this manufacturer?"}
                        open={openConfirmDialog}
                        setOpen={setOpenConfirmDialog}
                        onConfirm={() => {
                            deleteManufacturer(manufacturerId)
                                .then((res) => {
                                    alertSuccess({
                                        title: "Deleted!",
                                        customMessage: "Manufacturer deleted successfully.",
                                    });
                                    history.push("/manufacturers");
                                })
                                .catch((error) => {
                                    alertError({
                                        error: error,
                                        customMessage: "Could not delete the manufacturer.",
                                    });
                                });
                        }}
                    />
                </>
            )}
        </>
    );
}